// src/utils/translate.js
const API_URL = "https://translation.googleapis.com/language/translate/v2";

async function translateBatch({ texts, sourceLang, targetLang, accessToken }) {
  if (!texts || !texts.length) return [];
  if (!accessToken) throw new Error("Missing accessToken");

  const resp = await fetch(API_URL + `?key=${accessToken}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      q: texts,
      source: sourceLang,
      target: targetLang,
      format: "text",
      // model: "nmt",
    }),
  });

  var data = null, raw = "";
  try { data = await resp.json(); }
  catch (e) { try { raw = await resp.text(); } catch (e2) {} }

  if (!resp.ok) {
    var msg = (data && data.error && data.error.message) ||
              (data && data.message) ||
              raw || ("HTTP " + resp.status);
    throw new Error("Translation API error: " + msg);
  }

  var translations = (data && data.data && data.data.translations) ? data.data.translations : [];
  return translations.map(function (t) {
    return (t && typeof t.translatedText === "string") ? t.translatedText : "";
  });
}

export async function translateHtmlWithExclusions({
  html,
  sourceLang,
  targetLang,
  accessToken,
  excludeTags = [
    "script","style","noscript",
    "code","pre","samp","kbd","var",
    "textarea","select","option","optgroup",
    "button","input","label",
    "img","svg","math","canvas","video","audio","track","source","picture","iframe","object","embed",
    "title"
  ],
}) {
  if (!html) return "";
  if (sourceLang === targetLang) return html;
  if (!accessToken) throw new Error("Missing accessToken");

  // 1) kontajner
  var container = document.createElement("div");
  container.innerHTML = html;

  // 2) kontroly
  var excluded = new Set(excludeTags.map(function (t) { return String(t).toLowerCase(); }));
  var ALWAYS_EXCLUDE = new Set(["script","style"]); // istota

  function isInsideExcludedTag(node) {
    for (var n = node.parentNode; n && n !== container; n = n.parentNode) {
      if (n.nodeType === 1) { // ELEMENT_NODE
        var tag = n.tagName.toLowerCase();
        if (ALWAYS_EXCLUDE.has(tag) || excluded.has(tag)) return true;
      }
    }
    return false;
  }

  // 3) walker cez texty
  var walker = document.createTreeWalker(
    container,
    NodeFilter.SHOW_TEXT,
    {
      acceptNode: function (textNode) {
        var val = (textNode && textNode.nodeValue != null) ? textNode.nodeValue : "";
        if (!val.trim()) return NodeFilter.FILTER_REJECT; // iba whitespace
        return isInsideExcludedTag(textNode)
          ? NodeFilter.FILTER_REJECT
          : NodeFilter.FILTER_ACCEPT;
      }
    }
  );

  // 4) zozbieraj texty v poradí
  var items = []; // { node, original }
  var cur;
  while ((cur = walker.nextNode())) {
    items.push({ node: cur, original: cur.nodeValue });
  }

  // 5) prelož dávku (poradie zachované)
  var originals = items.map(function (it) { return it.original; });
  // PREKLAD
  var translated = await translateBatch({
    texts: originals,
    sourceLang: sourceLang,
    targetLang: targetLang,
    accessToken: accessToken,
  });

  // 6) vráť späť podľa indexov
  translated.forEach(function (t, i) { items[i].node.nodeValue = t; });

  // 7) výsledok
  return container.innerHTML;
}
